/**
 * Converts a text to a URL-safe slug, e.g. "Maria Ștefan" → "maria-stefan".
 * Must stay identical to toUrlSlug() in backend/core.php: the server redirects
 * every other spelling of a URL to the slug it computes itself.
 */
export function toSlug(str, fallback = "") {
    const slug = String(str ?? "")
        .toLowerCase()
        .replace(/[ăâ]/g, "a")
        .replace(/î/g, "i")
        .replace(/[șş]/g, "s")
        .replace(/[țţ]/g, "t")
        .replace(/[^a-z0-9\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-");

    return slug || fallback;
}

/**
 * Builds a woman profile URL slug.
 * e.g. toWomanSlug("Maria", "Ștefan", 42) → "maria-stefan_42"
 */
export function toWomanSlug(name, surname, id) {
    return toSlug(`${name ?? ""} ${surname ?? ""}`, "profil") + "_" + id;
}

const TAXONOMY_PATHS = {
    category: { segment: "categorie", fallback: "categorie" },
    place: { segment: "tara", fallback: "tara" },
};

/**
 * Path of a category ("domeniu") or place ("țară") page, always built from the Romanian name.
 * e.g. toTaxonomyPath("category", { id: 20, base_name: "Sport" }) → "/categorie/sport_20"
 */
export function toTaxonomyPath(type, item) {
    const config = TAXONOMY_PATHS[type] || TAXONOMY_PATHS.category;
    const baseName = item?.base_name ?? item?.name ?? "";

    return `/${config.segment}/${toSlug(baseName, config.fallback)}_${item?.id ?? ""}`;
}

export function getWomanCategoryPath(woman) {
    if (!woman?.category_id) return "";

    return toTaxonomyPath("category", {
        id: woman.category_id,
        base_name: woman.category_base_name ?? woman.category_name,
    });
}

export function getWomanPlacePath(woman) {
    if (!woman?.place_id) return "";

    return toTaxonomyPath("place", {
        id: woman.place_id,
        base_name: woman.place_base_name ?? woman.place_name,
    });
}

/** Numeric id at the end of a slug ("sport_20" → 20, "20" → 20). */
export function getIdFromSlug(slug) {
    const value = String(slug ?? "");

    if (/^\d+$/.test(value)) return parseInt(value, 10);

    const match = value.match(/_(\d+)$/);

    return match ? parseInt(match[1], 10) : 0;
}
